/**
 * Shown by route guards when a page's flag resolves disabled while the
 * feature flag system itself is unavailable (source === 'unleash-failed'),
 * and by HomeRoute when no safe redirect target exists. Rendering a stable
 * panel instead of issuing a redirect prevents the `/` ↔ `/endpoints`
 * redirect loop that blanked the app during a flag outage (task 339).
 *
 * Styled to match the existing error/empty states (see AmsUnavailable).
 * Renders inside AppLayout's content area, so it is not full-screen.
 */
export default function FeatureFlagsUnavailable() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-24 px-6 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/30">
        <svg
          className="h-6 w-6 text-amber-600 dark:text-amber-400"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.8}
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
          />
        </svg>
      </div>
      <h1 className="text-xl font-semibold text-gray-900 dark:text-white">
        This page is temporarily unavailable
      </h1>
      <p className="text-sm text-gray-600 dark:text-gray-400 max-w-md">
        We couldn&apos;t load the feature settings that control this page. This
        is usually temporary — please try again in a few moments.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="mt-2 px-4 py-2 bg-indigo-600 text-white rounded-md text-sm hover:bg-indigo-700 transition-colors"
      >
        Reload
      </button>
    </div>
  );
}
